// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"0f0c1c44","550":"7c6e1d22","807":"11260cdf","858":"fe43fabe"}[chunkId] + ".chunk.js";
};